import React from "react";
import styled, { css } from "styled-components";
import type { ChangeRate } from "types/BusinessDashboard";
import {
  TriangleBlueIcon,
  TriangleRedIcon,
} from "assets/icons/businessDashboard";

const IndicatorSpan = styled.span<{
  $smallFont?: boolean;
  $color?: string;
}>`
  display: flex;
  align-items: center;
  gap: 4px;

  ${({ $smallFont }) =>
    $smallFont
      ? css`
          font-size: 12px;
          font-weight: 500;
          line-height: 16px;
          letter-spacing: -0.2px;
        `
      : css`
          font-size: 15px;
          font-weight: 700;
          line-height: 22px;
          letter-spacing: -0.2px;
        `}

  color: ${({ $color }) => $color || "#6b7280"};
`;

export const SalesChangeIndicator = ({
  changeRate,
  smallFont = false,
  showIcon = true,
}: {
  showIcon?: boolean;
  smallFont?: boolean;
  changeRate?: ChangeRate;
}) => {
  if (!changeRate) return null; // 데이터가 없는 경우

  if (changeRate.calculable === null) {
    return (
      <IndicatorSpan $smallFont={smallFont} $color="#6b7280">
        0.0%
      </IndicatorSpan>
    );
  }

  // 계산 불가능한 경우
  if (!changeRate.calculable) {
    const Icon =
      changeRate.positive === true ? TriangleBlueIcon : TriangleRedIcon;
    const color = changeRate.positive === true ? "#1F6AFF" : "#FD4235";
    const valueText = changeRate.positive === true ? "∞" : "-∞";

    return (
      <IndicatorSpan $smallFont={smallFont} $color={color}>
        {showIcon && <Icon />}
        {valueText}%
      </IndicatorSpan>
    );
  }

  // 계산 가능한 경우
  const value = changeRate.value ?? 0;

  let IconComponent;
  let color;

  if (value > 0) {
    IconComponent = TriangleBlueIcon;
    color = "#1F6AFF";
  } else if (value < 0) {
    IconComponent = TriangleRedIcon;
    color = "#FD4235";
  } else {
    color = "#6b7280";
  }

  return (
    <IndicatorSpan $smallFont={smallFont} $color={color}>
      {value !== 0 && showIcon && IconComponent && <IconComponent />}
      {!showIcon && value > 0 ? "+" + value.toFixed(1) : value.toFixed(1)}%
    </IndicatorSpan>
  );
};
